// extracted by mini-css-extract-plugin
module.exports = {"background":"ResultsPage_background__c1ebO"};